module.exports = __webpack_public_path__ + "img/logo_22.973b8836.png";